import { Form, FormItemProps, Input, InputProps } from 'antd';
import { PasswordProps, TextAreaProps } from 'antd/es/input';

interface InputFormProps {
  formProps?: FormItemProps;
  inputPasswordProps?: PasswordProps;
  inputProps?: InputProps;
  inputTextAreaProps?: TextAreaProps;
  isPassword?: boolean;
  isTextArea?: boolean;
}

export const InputForm = ({
  formProps,
  inputPasswordProps,
  inputProps,
  inputTextAreaProps,
  isPassword,
  isTextArea = false,
}: InputFormProps) => {
  const renderInputs = () => {
    if (isTextArea) {
      return (
        <Input.TextArea
          {...inputTextAreaProps}
          placeholder={inputTextAreaProps?.placeholder ?? ''}
        />
      );
    }

    if (isPassword) {
      return (
        <Input.Password
          {...inputPasswordProps}
          placeholder={inputPasswordProps?.placeholder ?? ''}
        />
      );
    }

    return (
      <Input {...inputProps} placeholder={inputProps?.placeholder ?? ''} />
    );
  };

  return (
    <Form.Item
      {...formProps}
      hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
    >
      {renderInputs()}
    </Form.Item>
  );
};
